import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import { Icon, Expandable, Checkbox } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import { capitalize } from 'helpers/content';
import { Collapsible } from 'UI';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import DOMPurify from "dompurify";
import './_SelectMatricesForm.scss';

var SelectMatricesForm = function SelectMatricesForm(props) {
  var course = props.course,
      part = props.part;
  var translate = useTranslate();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  useEffect(function () {
    if (part == null || part.assessmentBlockPartRows == null) {
      return null;
    }

    var rows = [];
    part.assessmentBlockPartRows.forEach(function (row) {
      rows.push(row);
    }); // Only update selectedRows if rows don't already exist in selectedRows

    if (rows.filter(function (row) {
      return selectedRows.some(function (selectedRow) {
        return selectedRow.referenceId == row.referenceId;
      });
    }).length != rows.length) {
      setSelectedRows(rows);
    }

    return null;
  }, [part]);
  useEffect(function () {
    if (props.onChange != null) {
      var matrix = getMatrix();

      if (matrix == null) {
        // Dont add value for this course if matrix is null
        return null;
      }

      var relations = [{
        'courseId': course.id
      }];

      if (part != null && part.assessmentBlockPartRelationships != null) {
        relations = part.assessmentBlockPartRelationships;
      } // Build assessmentPart object for course


      props.onChange(_objectSpread(_objectSpread({}, props.part), {}, {
        'referenceId': matrix.id,
        'assessmentBlockPartRows': selectedRows,
        'assessmentBlockPartRelationships': relations
      }));
    }
  }, [selectedRows]);

  var getCourseDetail = function getCourseDetail() {
    return course.details.find(function (detail) {
      return detail.matrixID == part.referenceId;
    });
  };

  var getMatrix = function getMatrix() {
    var _course$details$find;

    if (part == null || part.referenceId == null || part.referenceId == '' || part.referenceId == 0) {
      var _course$details$filte;

      return (_course$details$filte = course.details.filter(function (detail) {
        return detail.endDate == null || moment(detail.endDate).isAfter(moment());
      })[0]) === null || _course$details$filte === void 0 ? void 0 : _course$details$filte.matrix;
    }

    return (_course$details$find = course.details.find(function (detail) {
      return detail.matrixID == part.referenceId;
    })) === null || _course$details$find === void 0 ? void 0 : _course$details$find.matrix;
  };
  /**
   * @param {object} row
   */


  var getRowClarifications = function getRowClarifications(row) {
    if (props.clarifications == null) {
      return [];
    }

    var found = props.clarifications.find(function (clarification) {
      if (clarification.value == null) {
        return false;
      }

      return clarification.value.title == row.id;
    });

    if (found == null) {
      return [];
    }

    return found.value.rows;
  };

  var removeCourse = function removeCourse(event) {
    event.preventDefault();
    event.stopPropagation();

    if (props.onRemove != null) {
      props.onRemove();
    }
  };

  var onToggleRow = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(row) {
      var selected;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selected = selectedRows.find(function (selectedRow) {
                return selectedRow.referenceId == row.id;
              });

              if (selected != null) {
                setSelectedRows(selectedRows.filter(function (selectedRow) {
                  return selectedRow.referenceId != row.id;
                }));
              } else {
                setSelectedRows([].concat(_toConsumableArray(selectedRows), [{
                  'referenceType': 'matrixRow',
                  'referenceId': row.id
                }]));
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onToggleRow(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onToggleParagraph = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(active, paragraph) {
      var values, _values;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _toConsumableArray(selectedRows);

              if (active) {
                // Remove all previously selected rows for this paragraph
                values = values.filter(function (selectedRow) {
                  return paragraph.rows.find(function (r) {
                    return r.id == selectedRow.referenceId;
                  }) == null;
                }); // Add all rows as selected

                (_values = values).push.apply(_values, _toConsumableArray(paragraph.rows.map(function (row) {
                  return {
                    'referenceType': 'matrixRow',
                    'referenceId': row.id
                  };
                })));
              } else {
                // Remove selected rows for this paragraph
                values = values.filter(function (selectedRow) {
                  return paragraph.rows.find(function (r) {
                    return r.id == selectedRow.referenceId;
                  }) == null;
                });
              }

              setSelectedRows(values);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onToggleParagraph(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * @param {string} target
   * @param {string} referenceType
   * @description Toggles target permission on part data
   */


  var togglePermission = function togglePermission(target, referenceType) {
    var _props$part$permissio;

    var permissions = props.part.permissions;
    var indexOf = (_props$part$permissio = props.part.permissions) === null || _props$part$permissio === void 0 ? void 0 : _props$part$permissio.findIndex(function (element) {
      return element.target == target && element.referenceType == referenceType;
    });

    if (indexOf > -1) {
      permissions.splice(indexOf, 1);
    } else {
      permissions.push({
        target: target,
        referenceType: referenceType,
        level: 'READ'
      });
    }

    props.onChange(_objectSpread(_objectSpread({}, props.part), {}, {
      permissions: permissions
    }));
  };
  /**
   * @param {string} target
   */


  var renderPermission = function renderPermission(target) {
    var _props$part$permissio2;

    var active = ((_props$part$permissio2 = props.part.permissions) === null || _props$part$permissio2 === void 0 ? void 0 : _props$part$permissio2.find(function (element) {
      return element.target == target && element.referenceType == 'ASSESSMENTBLOCKPART';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active",
      onClick: function onClick(event) {
        event.stopPropagation();
        togglePermission(target, 'ASSESSMENTBLOCKPART');
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize(target)));
  };

  var renderAssessmentFeedbackPermission = function renderAssessmentFeedbackPermission() {
    var _props$part$permissio3;

    var active = ((_props$part$permissio3 = props.part.permissions) === null || _props$part$permissio3 === void 0 ? void 0 : _props$part$permissio3.find(function (element) {
      return element.target == 'GUARDIAN' && element.referenceType == 'ASSESSMENTFEEDBACK';
    })) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission active",
      onClick: function onClick(event) {
        event.stopPropagation();
        togglePermission('GUARDIAN', 'ASSESSMENTFEEDBACK');
      }
    }, props.assessmentType == ASSESSMENT_TYPES.TEACHER && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize('Show feedback for guardians'))));
  };

  var renderExpiredText = function renderExpiredText() {
    var courseDetail = getCourseDetail();

    if (courseDetail != null && courseDetail.endDate != null && moment(courseDetail.endDate).isBefore(moment())) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        style: {
          marginRight: '0.5rem'
        },
        name: "Alert_Red"
      }), translate('Expired'));
    }

    return null;
  };

  var renderRowTitle = function renderRowTitle() {
    var courseTitle = course.year != null ? "".concat(course.title, " ").concat(course.year) : course.title;
    return /*#__PURE__*/React.createElement("div", {
      className: "matrix_header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "matrix_title"
    }, courseTitle, " ", renderExpiredText()), props.assessmentType == ASSESSMENT_TYPES.TEACHER && /*#__PURE__*/React.createElement("div", {
      className: "permission_box"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-tools"
    }, renderPermission('STUDENT')), /*#__PURE__*/React.createElement("div", {
      className: "row-tools"
    }, renderPermission('GUARDIAN'))), props.disableRows == null || props.disableRows.length == 0 ? /*#__PURE__*/React.createElement("div", {
      className: "controls row-tools"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: removeCourse
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Bin"
    }))) : null);
  };

  var getDisabledRowsForParagraph = function getDisabledRowsForParagraph(paragraph) {
    if (props.disableRows == null || props.disableRows.length == 0) {
      return [];
    }

    var disabled = [];
    paragraph.rows.forEach(function (row) {
      var reference = props.part.assessmentBlockPartRows.find(function (partRow) {
        return partRow.referenceId == row.id;
      });

      if (reference == null) {
        return false;
      }

      if (props.disableRows.indexOf(reference.id) > -1) {
        disabled.push(row.id);
      }
    });
    return disabled;
  };

  var renderMatrix = function renderMatrix() {
    var matrix = getMatrix();
    var courseDetail = getCourseDetail();
    var isExpiredCourseDetail = courseDetail != null && courseDetail.endDate != null && moment(courseDetail.endDate).isBefore(moment());

    if (matrix == null || matrix._ParagraphSet == null) {
      return null;
    }

    return matrix._ParagraphSet.map(function (paragraph) {
      var active = true;
      var disabledRows = getDisabledRowsForParagraph(paragraph);
      paragraph.rows.forEach(function (row) {
        if (selectedRows.find(function (selectedRow) {
          return selectedRow.referenceId == row.id;
        }) == null) {
          active = false;
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "paragraph",
        key: paragraph.id
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(active) {
          return onToggleParagraph(active, paragraph);
        },
        value: active,
        disabled: disabledRows.length > 0 || isExpiredCourseDetail
      }), /*#__PURE__*/React.createElement("span", {
        className: "matrix-paragraph-title"
      }, paragraph.title), paragraph.subtitle != null ? /*#__PURE__*/React.createElement("div", {
        className: "matrix-paragraph-subtitle"
      }, paragraph.subtitle) : null), paragraph.rows.map(function (row, index) {
        var selected = selectedRows.find(function (selectedRow) {
          return selectedRow.referenceId == row.id;
        }) != null;
        var clarifications = getRowClarifications(row);
        return /*#__PURE__*/React.createElement(Fragment, {
          key: row.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "df row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "df ais"
        }, /*#__PURE__*/React.createElement("div", {
          className: "df aic"
        }, /*#__PURE__*/React.createElement("div", null, paragraph.paragraphNr, ".", row.sentenceNr), /*#__PURE__*/React.createElement(Checkbox, {
          onChange: function onChange() {
            return onToggleRow(row);
          },
          value: selected,
          disabled: disabledRows.indexOf(row.id) > -1 || isExpiredCourseDetail
        }))), row.text != null ? /*#__PURE__*/React.createElement("div", {
          className: "column-text",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(row.text.replace(new RegExp("\r\n", "g"), "<br />"))
          }
        }) : null, /*#__PURE__*/React.createElement("div", {
          className: "cells df"
        }, row.cells.map(function (cell) {
          return /*#__PURE__*/React.createElement("div", {
            className: "cell",
            key: cell.id
          }, cell.text);
        }))), clarifications.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "clarifications select-matrices-form"
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: translate('Clarifications')
        }, clarifications.map(function (clarification) {
          return /*#__PURE__*/React.createElement("div", {
            className: "df row",
            key: clarification.id
          }, clarification.description != null ? /*#__PURE__*/React.createElement("div", {
            className: "column-text",
            dangerouslySetInnerHTML: {
              __html: DOMPurify.sanitize(clarification.description.replace(new RegExp("\r\n", "g"), "<br />"))
            }
          }) : null, /*#__PURE__*/React.createElement("div", {
            className: "cells df"
          }, clarification.cells.map(function (cell) {
            return /*#__PURE__*/React.createElement("div", {
              className: "cell",
              key: cell.id
            }, cell.value);
          })));
        }), /*#__PURE__*/React.createElement("div", {
          className: "color--meta"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Alert",
          bw: true
        }), " ", translate('Existing clarifications will not be copied and cannot be edited. Move them to an assessment goal instead.')))) : null);
      }));
    });
  };

  if (course == null) {
    return null;
  }

  var color = '#ccc';

  if (course.colorCode != null) {
    color = course.colorCode;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "select-matrices-form"
  }, /*#__PURE__*/React.createElement(Expandable, {
    title: renderRowTitle(),
    color: color,
    open: true,
    ignorePropsUpdate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "guardian-feedback-permission"
  }, renderAssessmentFeedbackPermission()), props.disabled ? /*#__PURE__*/React.createElement("div", {
    className: "disabled-notice"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Alert",
    bw: true
  }), translate('To be able to edit, you must first delete the assessments made.')) : null, renderMatrix()));
};

SelectMatricesForm.defaultProps = {
  disabled: false
};
export default SelectMatricesForm;